import { Media } from '../commonComponents/Media'
import classNames from 'classnames'
import { SecondaryButton } from './SecondaryButton'
import Image from 'next/image'
import PlayStore from '../../public/assets/playstore.png'
import HeroDesktop from '../../public/assets/hero_desktop_latest.webp'
import { useRouter } from 'next/router'

export const HomePageHero = ({modalOpen=false,setModalOpen,isSent, setIsSent, showToastHandler}) => {

  const router = useRouter();

  return (
    <>
      <div className="">
        <Media at="sm" className="">
          <div id="hero" className="h-[305px] w-[100%] p-[24px] flex"></div>
          <div className="below-content">
            <div className="flex w-[100vw] pt-[40px]">
              <div className={classNames(`p-[24px] pb-[16px] text-[48px]`)} id="hph_content">
                <div className='font-noto-sans text-greyTitleBase900'>Find the</div>
                <div className="font-noto-sans text-greyTitleBase900 font-bold">best jobs <br/> near you</div>
              </div>
            </div>
            <div className="w-[80%] pb-[24px] px-[24px] text-[16px] font-noto-sans leading-[24px] text-inputText">
              Download Lokal Jobs app and get access to{' '}
              <span className="text-black font-noto-sans"><b>50,00,000+</b> jobs</span> in{' '}
              <span className="text-black font-noto-sans"><b>70+</b> cities</span> across India.
            </div>
          </div>
        </Media>
        <Media greaterThan="sm">
          <div id="hero-desktop" className="flex sm:flex-wrap md:flex-nowrap items-center md:justify-between sm:justify-center w-[100%] sm:gap-7 md:gap-16 sm:p-[40px] md:p-[70px] mt-[75px]">
            <div id="left" className="">
              <div className="font-noto-sans md:max-w-[455px] text-[56px] font-[300] text-greyTitleBase900 text-left leading-[55px] tracking-[-1.68px]">
              Find the{' '}<span className="font-[600]">best jobs near you</span>
              </div>
              <p className="mt-[16px] text-left">
                Download Lokal Jobs app and get access to 50,00,000+ jobs in 70+ cities across
                India.
              </p>
              <div id="btn" className="mt-[24px] flex gap-[16px] min-w-[360px]">
                <div className='w-fit'>
                  <SecondaryButton title={'Search Jobs'} className='h-[48px] border-[#989898]' customPadding={`px-[24px] py-[14px]`}onClick={()=>{
                    router.push('/jobs/jobs-near-me')
                   
                  }}/>
                </div>
              </div>
              <div id="playstore" className="font-noto-sans mt-[8px] text-[14px] text-[#666] text-left">
                <Image src={PlayStore} width={16} height={16} alt='playstore' /> 10,00,000,+ downloads
              </div>
            </div>
            <div id="right">
              <Image src={HeroDesktop} width={519} height={364} alt="hero_lokal.jobs" />
            </div>
          </div>
        </Media>
      </div>
    </>
  )
}
